import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { usePrintSettings } from '../../core/hooks';
import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import PrintDocumentMenuItem from '../../../../components/print-document-menu-item';
import { usePackingSlip } from '../hooks/use-packing-slip';

export const PackingSlip = ({ selectedData }) => {
  const { isDisabled, onClick, onDownload, onPrint } = usePackingSlip({
    fulfillments: selectedData,
  });
  const printSettings = usePrintSettings(DocumentType.PackingSlip.printSettingKey);
  const defaultPrintSetting = useMemo(
    () => buildDefaultPrintSetting(printSettings, onPrint, onDownload),
    [onDownload, onPrint, printSettings],
  );

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={isDisabled}
      name={DocumentType.PackingSlip.documentNameTranslation}
      onClick={onClick}
    />
  );
};

PackingSlip.propTypes = {
  selectedData: PropTypes.array.isRequired,
};
